/* eslint-disable no-console */
import { Auth } from 'aws-amplify';
import BaseComponent from 'foundation/base-component';
import Cookies from 'js-cookie';
import api from 'general/js/api';
import _ from 'lodash';
import app from '../../../general/js/app';
import { addQueryParams, redirectTo } from '../../../general/js/utils';
import { QueryConstants } from '../../../general/js/utils/query-constants';

export default class TicketResaleForceSignInComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        const jsonOptions = this.getAttribute(this.element, 'options');
        this.ticketResaleOptions = JSON.parse(jsonOptions);

        this.processRequest();
    }

    processRequest() {
        if (this.options.useCognito) {
            this.handleCognitoUserValidation();
            return;
        }

        this.handleSecutixUserValidation();
    }

    handleCognitoUserValidation() {
        Auth.currentAuthenticatedUser(false)
            .then((user) => {
                this.authenticatedUserData = user;
                const userEmail = this.authenticatedUserData.attributes.email;
                const userMemberships = this.authenticatedUserData.attributes['custom:Membership'];

                if (this.ticketResaleOptions.dataSource.checkOneClubMembership && !userMemberships.includes('OneClub')) {
                    redirectTo(this.ticketResaleOptions.dataSource.notOneClubMemberErrorPage.url);
                    return;
                }

                this.processRedirectToWaitingList(userEmail);
            }).catch((error) => {
                console.log(error);
                redirectTo(this.getCognitoSignInPageUrl());
            });
    }

    handleSecutixUserValidation() {
        const userData = this.getCookieData(app.state.userDataCookieName);

        if (this.shouldRedirectToSignInPage(userData)) {
            redirectTo(this.getSecutixSignInPageUrl());
            return;
        }

        if (this.shouldRedirectToOneClubMemberErrorPage(userData)) {
            redirectTo(this.ticketResaleOptions.dataSource.notOneClubMemberErrorPage.url);
            return;
        }

        const linksConfigurationData = this.getCookieData(app.state.linksConfigurationCookieName);
        const userEmail = linksConfigurationData.username;

        this.processRedirectToWaitingList(userEmail);
    }

    getCookieData(cookieName) {
        const cookieValue = Cookies.get(cookieName);
        return _.isEmpty(cookieValue) ? {} : JSON.parse(cookieValue);
    }

    getSecutixSignInPageUrl() {
        const checkOneClubMembership = this.shouldCheckForOneClubMembership();

        return `${this.ticketResaleOptions.dataSource.signInPage.url}?joinOneClub=${checkOneClubMembership}`;
    }

    getCognitoSignInPageUrl() {
        const checkOneClubMembership = this.shouldCheckForOneClubMembership();

        return addQueryParams(this.ticketResaleOptions.dataSource.signInPage.url, [
            {
                key: QueryConstants.JOIN_ONE_CLUB,
                value: checkOneClubMembership
            },
            {
                key: QueryConstants.REDIRECT_TO,
                value: window.location.pathname
            }
        ]);
    }

    shouldCheckForOneClubMembership() {
        return this.ticketResaleOptions.dataSource.checkOneClubMembership ?
            this.ticketResaleOptions.dataSource.checkOneClubMembership :
            false;
    }

    shouldRedirectToSignInPage(userData) {
        return _.isEmpty(userData) ||
            !userData.isSignedIn;
    }

    shouldRedirectToOneClubMemberErrorPage(userData) {
        return this.ticketResaleOptions.dataSource.checkOneClubMembership &&
            userData.isSignedIn &&
            !userData.isOneClubMember;
    }

    processRedirectToWaitingList(userEmail) {
        const addressBookId = this.ticketResaleOptions.dataSource.dotmailerAddressBookId;
        return api.get(`${this.ticketResaleOptions.verifyAddressBookCallBackUrl}?addressBookId=${addressBookId}&email=${userEmail}`)
            .then((isUserOnWaitingList) => {
                if (!isUserOnWaitingList.data) {
                    redirectTo(this.ticketResaleOptions.dataSource.notOnWaitingListErrorPage.url);
                }
            }).catch((error) => {
                console.log(error);
            });
    }
}
